module.exports = __webpack_public_path__ + "img/wechat_pay_scan.159ed084.png";